import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  formControl: {
    margin: theme.spacing(0)
  }
}));

const FilterNationals = props => {
  const { nationalFilter, resetComponent } = props;
  const classes = useStyles();
  const [checked, setChecked] = useState(false);

  const handleChange = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    if (checked) {
      nationalFilter(true);
    } else {
      nationalFilter(false);
    }
  }, [checked]);

  useEffect(() => {
    if (resetComponent) {
      nationalFilter(false);
      setChecked(false);
    }
  }, [resetComponent]);

  return (
    <div>
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <div className="nationalOrgCheckbox" style={{ width: "100%" }}>
            <FormControlLabel
              control={<Checkbox checked={checked} onChange={handleChange} />}
              label="National Organizations"
            />
          </div>
        </FormControl>
      </div>
    </div>
  );
};
export default FilterNationals;
